import React, { Component } from 'react'
import { connect } from 'react-redux'
import { DragSource, DropTarget } from 'react-dnd'
import { getEmptyImage } from 'react-dnd-html5-backend'
import classnames from 'classnames'

import { deleteMenu, moveMenu, dropMenu } from '../../actions/design/blogmenu'
import { typeIdToName } from './BlogMenuHelper'

function ExtraInfo({item}) {
  if (item.typeId < 9) {
    return null
  }

  let name = typeIdToName(item.typeId)
  let url = item.url
  if (item.typeId === 9 && item.url == "0") {
    url = "전체"
  }

  return (
    <span className="txt_cate">
      <span className="txt_g">{name}</span>
      <span className="ico_blog" /> {url}
    </span>
  )
}


@connect((state) => ({}), (dispatch) => ({
	handleDelete: (index) => {
		dispatch(deleteMenu(index))
	},
	handleMove: (dragIndex, hoverIndex, isTemporary) => {
		dispatch(moveMenu(dragIndex, hoverIndex, isTemporary))
	},
	handleDrop: (dragIndex) => {
		dispatch(dropMenu(dragIndex))
	}
}))
@DragSource(
	'item',
	{
		beginDrag: (props, monitor, component) => ({
			index: props.index,
			item: props.item
		}),
		endDrag: (props, monitor, component) => {
			props.handleDrop(monitor.getItem().index)
		}
	},
	(connect, monitor) => ({
		connectDragSource: connect.dragSource(),
		connectDragPreview: connect.dragPreview(),
		isDragging: monitor.isDragging()
	})
)
@DropTarget(
	'item',
	{
		hover: (props, monitor, component) => {
			const dragIndex = monitor.getItem().index
			const hoverIndex = props.index

			if (dragIndex === hoverIndex) {
				return;
			}

			props.handleMove(dragIndex, hoverIndex, true)
			monitor.getItem().index = hoverIndex;
		}
	},
	(connect, monitor) => ({
		connectDropTarget: connect.dropTarget()
	})
)
class BlogMenuItem extends Component {

	componentDidMount() {
		const { connectDragPreview } = this.props
		connectDragPreview(getEmptyImage(), {
			captureDraggingState: true
		})
	}

	render() {
		const { index, item, connectDragSource, connectDropTarget, handleDelete } = this.props

		return connectDropTarget(
			<div className={classnames("bundle_item", { "insert_item": item.isTemporary })}>
				<div className="item_order">
					<div className="basic_item">
						{ connectDragSource(
							<div className="wrap_drag">
								<span className="ico_blog ico_drag" />
							</div>
						) }
						<span className="txt_name">{item.name}</span>

            <ExtraInfo item={item} />

            <div className="info_btn">
              <button className="btn_post" onClick={() => handleDelete(index)}>삭제</button>
            </div>
					</div>
				</div>
			</div>
		)
	}
}

export default BlogMenuItem
